import { plainToInstanceWithLVS } from '@goparrot/common';
import { BaseFacade } from '../../common';
import { ReadServiceChargeDto } from '../generated-dto';
import { ServiceChargeExposeGroup } from '../interface';
export class ServiceChargeFacade extends BaseFacade {
    async create(storeId, payload) {
        const url = `api/v2/stores/${storeId}/service-charges`;
        return plainToInstanceWithLVS(ReadServiceChargeDto, (await this.client.post(url, payload)).data, {
            groups: [ServiceChargeExposeGroup.READ],
        });
    }
    async list(storeId) {
        const url = `api/v2/stores/${storeId}/service-charges`;
        return plainToInstanceWithLVS(ReadServiceChargeDto, (await this.client.get(url)).data, {
            groups: [ServiceChargeExposeGroup.READ],
        });
    }
    async get(storeId, uuid) {
        const url = `api/v2/stores/${storeId}/service-charges/${uuid}`;
        return plainToInstanceWithLVS(ReadServiceChargeDto, (await this.client.get(url)).data, {
            groups: [ServiceChargeExposeGroup.READ],
        });
    }
    async patch(storeId, uuid, operations) {
        const url = `api/v2/stores/${storeId}/service-charges/${uuid}`;
        return plainToInstanceWithLVS(ReadServiceChargeDto, (await this.client.patch(url, operations)).data, {
            groups: [ServiceChargeExposeGroup.READ],
        });
    }
    async delete(storeId, uuid) {
        await this.client.delete(`api/v2/stores/${storeId}/service-charges/${uuid}`);
    }
}
//# sourceMappingURL=ServiceChargeFacade.js.map